import { render, staticRenderFns } from "./modalAddNewTemplateVersion.vue?vue&type=template&id=bd29c71a&"
import script from "./modalAddNewTemplateVersion.vue?vue&type=script&lang=js&"
export * from "./modalAddNewTemplateVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports